import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsAreasListRoute extends Route {
  @service store;

  model() {
    return this.store.findAll('area');
  }
}

export default instrumentRoutePerformance(SettingsAreasListRoute);
